export enum TEXT_STYLES {
  H1,
  H2,
  H3,
  H4,
  H5,
  HEADLINE,
  P,
  SECTION,
  TAGLINE,
}

export type TextStyles = typeof TEXT_STYLES[keyof typeof TEXT_STYLES];
